import { Components, Theme } from '@mui/material/styles';

export default (): Components<Theme>['MuiFab'] => ({
  styleOverrides: {
    root: {
      borderRadius: '50%'
    }
  }
});
